import { render, staticRenderFns } from "./modalPedidos.vue?vue&type=template&id=2f091cca&scoped=true"
import script from "./modalPedidos.vue?vue&type=script&lang=js"
export * from "./modalPedidos.vue?vue&type=script&lang=js"
import style0 from "./modalPedidos.vue?vue&type=style&index=0&id=2f091cca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f091cca",
  null
  
)

export default component.exports